import React, {useEffect, useState} from 'react';
import {Mic, MicOff} from "@material-ui/icons";
import {useSelector} from "react-redux";
import {ParticipantControl} from "../../../layout/layout";

const ParticipantAudioIndicator = ({id, onClick}) => {
    const [isEnabled, setIsEnabled] = useState(false);

    const audio = useSelector(store => {
        if (id === 'local')
            return [store.audioVideo.localTracks.audio];
        return store.audioVideo.remoteAudioTracks[id];
    });

    const hasMic = useSelector(state => {
        if (id === 'local')
            return state.audioVideo.localState?.hasMic
        return state.audioVideo.participants[id]?.hasMic
    });


    useEffect(() => {
        setIsEnabled(audio && audio.filter(track => {
            if (id === 'local') return track?.isEnabled
            return track?.isTrackEnabled;
        }).length > 0)
    }, [audio, id])

    if (!hasMic || isEnabled) return null;

    return (
        <ParticipantControl onClick={onClick}>
            {!isEnabled ? <MicOff/> : <Mic/>}
        </ParticipantControl>
    );
};

export default ParticipantAudioIndicator;